module.exports = __webpack_public_path__ + "img/logo-hauseful-symbol-dark.6b4727da.svg";